fx.translations("de", {
    "Commander" : "Bestellen",
    "Sauver & Quitter" : "Speichern & Beenden",
    "(hors livraison) :" : "(ohne Lieferung) :",
    "Votre ouvrage contient" :  "Ihr Werk enthält",
    "pages": "Seiten",

    "Carré" : "Quadrat",
    "Portrait" : "Porträt",
    "Paysage" : "Landschaft",

    "Rechercher" : "Suchen",
    "Ajouter" : "Hinzufügen",
    "Modifier" : "Bearbeiten",

    "Couleur" : "Farbe",

    "Réglages" : "Einstellungen",

    "Prix" : "Preis",

    "Album"  : "Fotobuch",

    "Recommandés" : "Empfohlen",

    "Photos" : "Fotos",
    "Modèles" : "Vorlagen",
    "Textes" : "Sätze",
    "Fonds" : "Hintergründe",
    "Stickers" : "Sticker",

    "Chargement ..." : "Laden ...",

    "Luminosité" : "Helligkeit",
    "Saturation" : "Sättigung",
    "Contraste" : "Kontrast",

    "couverture" : "Umschlag",

    "Ok" : "Ok",
    "OK" : "OK",

    "$ photos": "$ Fotos",

    "Vue globale" : "Gesamtansicht",
    "Zoomer" : "Zoomen",

    "Editeur" : "Editor",

    "Total" : "Gesamt",
    "hors livraison" : "ohne Lieferung",

    "Trier par ordre d'ajout" : "Sortieren nach Hinzufügungsreihenfolge",
    "Trier par date de photo" : "Sortieren nach Fotodatum",
    "Masquer les photos utilisées" : "Verwendete Fotos ausblenden",

    "Ajouter un titre" : "Titel hinzufügen",
    "Ajouter du texte" : "Text hinzufügen",
    "Modèles à personnaliser" : "Anpassbare Vorlagen",

    "Récupération des photos" : "Fotos wiederherstellen",
    "Ajouter $ photo$" : "$ Foto(s) hinzufügen",

    // popups
    "J'ai vérifié votre album, et j'ai constaté cela :" : "Ich habe Ihr Album überprüft und festgestellt, dass:",

    "Ca sera rapide ..." : "Es wird schnell gehen ...",
    "Il semble que la connexion soit un peu lente..." : "Die Verbindung scheint etwas langsam zu sein...",
    "La connexion doit vraiment être trop lente..." : "Die Verbindung muss wirklich zu langsam sein...",
    "La connexion est un peu lente..." : "Die Verbindung ist etwas langsam...",
    "J'essai de nouveau..." : "Ich versuche es noch einmal...",
    "Encore quelques secondes..." : "Noch ein paar Sekunden...",
    "La connexion est trop lente..." : "Die Verbindung ist zu langsam...",
    "J'insiste encore..." : "Ich bestehe weiterhin...",
    "On devrait y être bientôt..." : "Wir sollten bald da sein...",
    "Je sauvegarde" : "Ich speichere",
    "Ré-essayer" : "Erneut versuchen",

    "Je sauvegarde votre oeuvre d'art" : "Ich speichere Ihr Kunstwerk",

    "La sauvegarde a échouée !" : "Das Speichern ist fehlgeschlagen!",
    "Veuillez ré-essayer.<br>Sinon <a href='/contact' target='_blank'>contacter le service client</a>" : "Bitte versuchen Sie es erneut oder <a href='/kontakt' target='_blank'>kontaktieren Sie den Kundendienst</a>.",

    "Je prépare votre création" : "Ich bereite Ihre Fotos vor",
    "Ça va être génial !" : "Es wird großartig sein!",

    "On va créer quelque chose de beau" : "Wir gestalten etwas Schönes",
    "Je m'occupe de tout" : "Ich kümmere mich um alles",
    "Ce sera parfait !" : "Es wird perfekt!",
    "Ça arrive tout de suite" : "Gleich geht's los",
    "Je mets tout en place" : "Ich bringe alles an seinen Platz",
    "Vous êtes entre de bonnes mains" : "Du bist in guten Händen",
    "Encore un petit instant..." : "Nur noch einen Moment...",
    "C'est bientôt prêt" : "Gleich ist es fertig",
    "J'ouvre votre création" : "Ich öffne deine Kreation",
    "On reprend votre création" : "Wir setzen deine Kreation fort",
    "Je charge votre création" : "Ich lade deine Kreation",
    "Vous allez pouvoir continuer" : "Du kannst gleich weitermachen",
    "Bon retour !" : "Willkommen zurück!",

    "Votre album sera bientôt accessible" : "Ihr Album wird bald zugänglich sein",
    "Il est en cours d'envoi vers nos imprimantes." : "Es wird gerade an unsere Drucker gesendet.",

    "Revenir" : "Zurück",
    "Quel type de couverture<br>désirez-vous ?" : "Welche Art von Cover<br>wünschen Sie?",

    "Carnet Agrafé" : "Geheftetes Notizbuch",
    "Album Spirale" : "Spiralalbum",


    "Album Souple" : "Weiches Album",
    "Album Rigide" : "Hardcover-Album",
    "Album Ouverture à plat" : "Album mit Ringbindung",

    "Petit carré" : "Kleines Quadrat",
    "Grand carré" : "Großes Quadrat",
    "Petit Paysage" : "Kleine Landschaft",
    "Grand Paysage" : "Große Landschaft",
    "Petit Portrait" : "Kleines Porträt",
    "Grand Portrait" : "Großes Porträt",

    "21 x 21 cm" : "21 x 21 cm",
    "30 x 30 cm" : "30 x 30 cm",
    "21 x 15 cm" : "21 x 15 cm",
    "29,7 x 21 cm" : "29,7 x 21 cm",
    "15 x 21 cm" : "15 x 21 cm",
    "21 x 29,7 cm" : "21 x 29,7 cm",

    "Votre album contient $ pages" : "Ihr Album enthält $ Seiten",
    "dont $ pages additionnelles (+$ €)" : "darunter $ zusätzliche Seiten (+$ €)",
    "Changer la couverture" : "Ändern Sie Ihr Albumcover",
    "Changer la taille" : "Albumgröße ändern",

    "A partir de $ €" : "Ab $ €",
    "A partir de <strong>$€</strong>" : "Ab <strong>$€</strong>",

    "Quel type d'ouverture souhaitez-vous ?" : "Welche Art von Öffnung wünschen Sie?",
    "Ouverture normale" : "Normale Öffnung",
    "Ouverture à plat" : "Flache Öffnung",
    "Choisissez la forme de votre album" : "Wählen Sie die Form Ihres Albums",

    "Retour" : "Zurück",
    "Pages" : "Seiten",
    "Nombre de photos insuffisant" : "Nicht genügend Fotos",
    "Cliquez sur Retour, et ajoutez au moins $ photo(s) pour continuer la création de votre album." : "Klicken Sie auf Zurück und fügen Sie mindestens $ Foto(s) hinzu, um die Erstellung Ihres Albums fortzusetzen.",

    "Ajoutez des photos": "Fügen Sie Fotos hinzu",
    "photo": "Foto",

    "Fermer" : "Schließen",
    "Sauver" : "Speichern",
    "Annuler" : "Abbrechen",
    "Quitter" : "Schließen",

    "Cadrer" : "Zuschneiden",
    "Par défaut" : "Standard",

    "Etes-vous sûre ?" : "Sind Sie sicher?",
    "Cette photo est utilisée dans votre album.<br>Elle sera supprimée de toutes les pages ou elle apparaît." : "Dieses Foto wird in Ihrem Album verwendet.<br>Es wird von allen Seiten entfernt, auf denen es erscheint.",

    "Je la supprime" : "Ich lösche es",
    "Non" : "Nein",

    "En supprimant ce thème, toutes les mises en pages liées seront supprimées définitivement, et les clients n'y auront plus accès immédiatement." : "Durch das Löschen dieses Themas werden alle damit verbundenen Layouts dauerhaft gelöscht, und die Kunden haben keinen sofortigen Zugriff mehr darauf.",
    "Je le supprime" : "Ich lösche es",

    "Votre fichier est en cours d'import..." : "Ihre Datei wird importiert...",

    "Envoyer d'autres photos" : "Weitere Fotos senden",
    "Vos photos ont bien été envoyées" : "Ihre Fotos wurden erfolgreich gesendet",
    "Bravo !": "Bravo!",
    "Erreur !": "Fehler!",
    "Vos photos n'ont pas pu être téléchargées" : "Ihre Fotos konnten nicht hochgeladen werden",
    "Téléchargement en cours" : "Upload läuft",
    "Gardez la fenêtre de votre navigateur ouverte pendant le chargement de vos photos": " Lassen Sie das Browserfenster während des Hochladens Ihrer Fotos geöffnet",
    "Bienvenue" : "Willkommen",
    "Envoyer des photos" : "Fotos senden",

    "Je n'ai pas réussi à récupérer vos photos" : "Ich konnte Ihre Fotos nicht abrufen",
    "Un problème technique est survenu. Veuillez essayer de nouveau dans quelques instants." : "Es ist ein technisches Problem aufgetreten. Bitte versuchen Sie es in ein paar Augenblicken erneut.",
    "Mémoire insuffisante" : "Unzureichender Speicher",
    "Votre navigateur rencontre un problème de mémoire insuffisante. Veuillez le redémarrer pour régler le problème." : "Ihr Browser hat ein Problem mit unzureichendem Speicher. Bitte starten Sie ihn neu, um das Problem zu beheben.",
    "Ajout de vos photos..." : "Ihre Fotos hinzufügen...",
    "Import de vos photos ($)" : "Importieren Ihrer Fotos ($)",
    "Un fichier est déjà en cours d'import" : "Eine Datei wird bereits importiert",
    "Veuillez attendre que le premier fichier soit importé." : "Bitte warten Sie, bis die erste Datei importiert wurde.",
    "Je n'ai pas pu convertir votre fichier" : "Ich konnte Ihre Datei nicht konvertieren",
    "J'ai rencontré un problème en essayant de convertir votre fichier. Veuillez ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "Ich habe ein Problem beim Versuch festgestellt, Ihre Datei zu konvertieren. Bitte versuchen Sie es erneut oder <a href='/kontakt' target='_blank'>kontaktieren Sie unseren Kundendienst</a>.",
    "Ces fichiers n'ont pu être transférées" : "Diese Dateien konnten nicht übertragen werden",
    "Vérifiez votre connexion Internet (signal wifi faible, cable déconnecté, téléchargements en cours...), ou assurez-vous que votre fichier est encore accessible (fichier supprimé, ou disque externe déconnecté)." : "Überprüfen Sie Ihre Internetverbindung (schwaches WLAN-Signal, getrenntes Kabel, laufende Downloads...), oder stellen Sie sicher, dass Ihre Datei noch zugänglich ist (gelöschte Datei oder getrennte externe Festplatte).",

    "Plus tard" : "Später",
    "Votre fichier est en cours d'import" : "Ihre Datei wird importiert",
    "Je vous préviens dès que votre fichier est prêt à être utilisé." : "Ich informiere Sie, sobald Ihre Datei einsatzbereit ist.",
    "Un problème est survenu" : "Es ist ein Problem aufgetreten",
    "Je n'ai pas pu importer votre fichier. Veuillez ré-essayer ou contacter le <a href='/contact' target='_blank'>service client</a>." : "Ich konnte Ihre Datei nicht importieren. Bitte versuchen Sie es erneut oder <a href='/kontakt' target='_blank'>kontaktieren Sie den Kundenservice</a>.",
    "Je n'ai pas pu récupérer vos photos" : "Ich konnte Ihre Fotos nicht abrufen",
    "Un problème problème technique est arrivé, vos photos n'ont pu être récupérées. Veuillez-ré-essayer ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "Ein technisches Problem ist aufgetreten, Ihre Fotos konnten nicht abgerufen werden. Bitte versuchen Sie es erneut oder <a href='/kontakt' target='_blank'>kontaktieren Sie unseren Kundendienst</a>.",
    "Analyse de vos photos" : "Analyse Ihrer Fotos",
    "Recherche des moments clés" : "Suche nach Schlüsselmomenten",
    "Création de votre album" : "Erstellung Ihres Albums",
    "Votre album est prêt !" : "Ihr Album ist fertig!",
    "Je n'arrive pas à récupérer votre ouvrage" : "Ich kann Ihre Kreation nicht abrufen",
    "J'ai rencontré un problème en essayant de récupérer votre ouvrage. Veuillez-ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "Beim Versuch, Ihre Kreation abzurufen, ist ein Problem aufgetreten. Bitte versuchen Sie es erneut oder <a href='/kontakt' target='_blank'>kontaktieren Sie unseren Kundenservice</a>.",
    "Je n'ai pas pu charger les pages de votre fichier" : "Ich konnte die Seiten Ihrer Datei nicht laden",
    "J'ai rencontré un problème en essayant de charger les pages de votre fichier. Veuillez ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "Ich hatte ein Problem beim Laden der Seiten Ihrer Datei. Bitte versuchen Sie es erneut oder <a href='/kontakt' target='_blank'>kontaktieren Sie unseren Kundenservice</a>.",
    "Je n'ai pas pu charger cette mise en page" : "Ich konnte dieses Layout nicht laden",
    "J'ai rencontré un problème en essayant de charger cette mise en page. Veuillez ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "Ich hatte ein Problem beim Laden dieses Layouts. Bitte versuchen Sie es erneut oder <a href='/kontakt' target='_blank'>kontaktieren Sie unseren Kundendienst</a>.",

    "Votre album a été ouvert ailleurs" : "Ihr Album wurde anderswo geöffnet",
    "Pour éviter des problèmes de sauvegarde, veuillez garder l'album ouvert dans une page seulement." : "Um Sicher ungsprobleme zu vermeiden, halten Sie das Album bitte nur auf einer Seite offen.",

    "Une petite astuce ?" : "Ein kleiner Tipp?",
    "Pour sélectionner toutes les photos d'un répertoire, pressez en même temps les touches <strong>$ et A</strong>." : "Um alle Fotos in einem Verzeichnis auszuwählen, drücken Sie gleichzeitig die Tasten <strong>$ und A</strong>.",
    "Ok, c'est parti !" : "Ok, los geht's!",

    "Un problème avec votre connexion Internet ?" : "Ein Problem mit Ihrer Internetverbindung?",
    "Notre application n'arrive pas à se connecter à nos serveurs pour sauvegarder votre travail." : "Unsere Anwendung kann sich nicht mit unseren Servern verbinden, um Ihre Arbeit zu speichern.",
    "Tentative de reconnexion..." : "Versuch, die Verbindung wiederherzustellen...",

    "Ne perdez pas votre travail." : "Verlieren Sie nicht Ihre Arbeit.",
    "Sauvegardez votre travail, c'est simple et gratuit!<br><br>Votre création sera conservé sans limite de temps, et vous pourrez continuer à la modifier quand vous le souhaitez." : "Speichere deine Arbeit, es ist einfach und kostenlos!<br><br>Deine Kreation wird ohne Zeitbegrenzung aufbewahrt, und du kannst sie jederzeit weiter bearbeiten.",

    "Connectez-vous" : "Einloggen",
    "Votre email" : "Ihre E-Mail",
    "Votre mot de passe" : "Ihr Passwort",
    "Vous ne possedez pas encore de compte ?" : "Sie haben noch kein Konto?",
    "Se connecter" : "Einloggen",
    "Le format de votre email est incorrect" : "Das Format Ihrer E-Mail ist falsch",
    "Votre mot de passe doit contenir au moins 6 caractères" : "Ihr Passwort muss mindestens 6 Zeichen enthalten",
    "Veuillez saisir votre email et mot de passe" : "Bitte geben Sie Ihre E-Mail und Ihr Passwort ein",
    "Connexion" : "Verbindung",
    "Email ou mot de passe incorrect" : "E-Mail oder Passwort falsch",
    "Email déjà utilisé" : "E-Mail bereits verwendet",
    "Enregistrement" : "Registrierung",
    "Mot de passe incorrect" : "Passwort falsch",

    "Bienvenue chez Flexilivre !" : "Willkommen bei Flexilivre!",
    "Créez votre album en toute tranquillité, il est sauvegardé automatiquement sur votre compte." : "Erstellen Sie Ihr Album in aller Ruhe, es wird automatisch auf Ihrem Konto gespeichert.",

    "Sauvegarder votre ouvrage" : "Speichern Sie Ihr Werk",
    "Entrez votre email" : "Geben Sie Ihre E-Mail ein",
    "Choisissez votre mot de passe" : "Wählen Sie Ihr Passwort",
    "Vous possedez deja un compte?" : "Haben Sie bereits ein Konto?",
    "En poursuivant, vous acceptez lez conditions generales" : "Mit dem Fortfahren akzeptieren Sie die allgemeinen Bedingungen",

    "Ajout impossible" : "Hinzufügen unmöglich",
    "Votre album photo ne peut contenir plus de $ pages." : "Ihr Fotoalbum kann nicht mehr als $ Seiten enthalten.",
    "Suppression impossible" : "Löschen unmöglich",
    "Votre album photo ne peut contenir moins de $ pages." : "Ihr Fotoalbum kann nicht weniger als $ Seiten enthalten.",

    "Je n'arrive pas à sauvegarder votre création" : "Ich kann Ihr Werk nicht speichern",
    "J'ai rencontré un problème lors de la sauvegarde de votre création. Veuillez-ressayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "Beim Speichern Ihrer Erstellung ist ein Problem aufgetreten. Bitte versuchen Sie es erneut oder <a href='/contact' target='_blank'>kontaktieren Sie unseren Kundenservice</a>.",

    "Une erreur est arrivée" : "Ein Fehler ist aufgetreten",
    "Nous n'avons pu joindre le serveur. Veuillez ré-essayer de nouveau, ou contacter <a href='/contact/' target='_blank'>notre service technique</a>" : "Wir konnten den Server nicht erreichen. Bitte versuchen Sie es erneut oder kontaktieren Sie <a href='/kontakt/' target='_blank'>unseren technischen Service</a>.",

    "Texte de la tranche de l'album" : "Text des Albumrückens",
    "Texte" : "Text", 
    "Fond" : "Hintergrund",
    "Retourner" : "Umdrehen",
    "Tourner" : "Drehen",
    "Supprimer" : "Löschen",
    "Supprimer ces 2 pages" : "Diese 2 Seiten löschen",

    /* theme edit */
    "Sélectionnez la thématique" : "Thema auswählen",
    "Choisir ces modèles" : "Diese Modelle wählen",
    "Tous les modèles" : "Alle Modelle",
    "Sélectionnez un thème" : "Wählen Sie ein Thema",

    "Ouverture impossible" : "Öffnen unmöglich",
    "L'application d'édition ne peut être ouverte que depuis notre site" : "Die Bearbeitungsanwendung kann nur von unserer Website aus geöffnet werden",
    "Retourner sur Flexilivre.com" : "Zurück zu Flexilivre.com",

    // renderers
    "Photo utilisée" : "Verwendetes Foto",
    "Photo sélectionnée" : "Ausgewähltes Foto",

    // social
    "Si rien ne ne se passe après avoir cliqué sur le bouton ci-dessus, veuillez autoriser votre navigateur à afficher les popups." : "Wenn nach dem Klicken auf den obigen Button nichts passiert, erlauben Sie bitte Ihrem Browser, Pop-ups anzuzeigen.",
    "Cliquez sur le bouton ci-dessous pour vous connectez et autoriser notre application à importer vos photos." : "Klicken Sie auf den Button unten, um sich anzumelden und unserer Anwendung zu erlauben, Ihre Fotos zu importieren.",

    //stage
    "Cette image n'a pu être chargée" : "Dieses Bild konnte nicht geladen werden",
    "Ne placez pas visages au niveau de la séparation des pages,<br>ils risquent de ne pas se recouper parfaitement après la fabrication." : "Platzieren Sie keine Gesichter auf der Trennlinie der Seiten,<br>sie könnten nach der Herstellung nicht perfekt übereinstimmen.",
    "Votre photo n'est pas de qualité suffisante. Réduisez sa taille, ou remplacez-la par une meilleure photo." : "Ihr Foto ist nicht von ausreichender Qualität. Reduzieren Sie seine Größe oder ersetzen Sie es durch ein besseres Foto.",
    "Cliquez pour personnaliser la tranche" : "Klicken Sie, um den Buchrücken zu personalisieren",
    "L'ajout de texte sur la tranche n'est possible qu'avec une couverture rigide, ou avec plus de 40 pages." : "Das Hinzufügen von Text auf dem Buchrücken ist nur mit einem festen Einband oder mit mehr als 40 Seiten möglich.",
    "Ce bloc texte est trop proche du bord. Déplacez-le ou réduisez-le pour qu'il ne soit pas coupé lors de la fabrication." : "Dieser Textblock ist zu nah am Rand. Verschieben oder verkleinern Sie ihn, damit er bei der Herstellung nicht abgeschnitten wird.",

    "Votre texte dépasse !" : "Ihr Text ist zu lang!",
    "Votre texte est trop proche du bord de la page, il risque de ne pas être imprimé totalement." : "Ihr Text ist zu nah am Seitenrand, er könnte nicht vollständig gedruckt werden.",
    "Déplacez votre texte, ou réduisez-le." : "Verschieben oder verkleinern Sie Ihren Text.",

    "Ajouter deux pages" : "Zwei Seiten hinzufügen",
    "Chargement" : "Laden",
    "Modifier la couleur de fond" : "Hintergrundfarbe ändern",
    "Ajouter du texte" : "Text hinzufügen",
    "Le logo est supprimable au moment du passage de la commande.<br><br>Par contre, le QRCode n'est pas supprimable." : "Das Logo kann beim Bestellvorgang entfernt werden.<br>Der QR-Code kann jedoch nicht entfernt werden.",

    // data / filters
    "Recherche" : "Suche",
    "Fonds utilisés" : "Verwendete Hintergründe",
    "Fonds recommandés" : "Empfohlene Hintergründe",
    "Stickers utilisés" : "Verwendete Sticker",
    "Stickers recommandés" : "Empfohlene Sticker", 
    "Aucun résultat pour" : "Keine Ergebnisse für",
    "Pages simples" : "Einzelne Seiten",
    "Pages doubles" : "Doppelseiten",
    "Normal" : "Normal",
    "Lumière" : "Licht",
    "Contraste" : "Kontrast",
    "Couleur +" : "Farbe +",
    "Netteté" : "Schärfe",
    "Vieilli" : "Gealtert",
    "Noir & Blanc" : "Schwarz & Weiß",
    "Sepia" : "Sepia",
    "Focus" : "Fokus",
    "Vintage" : "Vintage",
    "Vintage 2" : "Vintage 2",
    "Ordre d'ajout" : "Hinzufügungsreihenfolge",
    "Ordre Chronologique" : "Chronologische Ordnung",
    "Par visage" : "Nach Gesicht",

    // data / models
    "Cliquez pour personnaliser la tranche" : "Klicken Sie hier, um den Buchrücken zu personalisieren",
    "L'ajout de texte sur la tranche n'est possible que si votre album contient au moins 40 pages" : "Text auf dem Buchrücken kann nur hinzugefügt werden, wenn Ihr Album mindestens 40 Seiten enthält",
    "L'ajout de texte sur la tranche n'est possible que : <ul><li>Sur une couverture rigide</li><li>Sur une couverture souple avec au moins 40 pages</li></ul>" : "Text auf dem Buchrücken kann nur hinzugefügt werden: <ul><li>Bei einem festen Einband</li><li>Bei einem weichen Einband mit mindestens 40 Seiten</li></ul>", 
    "Couverture Agrafée" : "Gehefteter Umschlag",
    "Couverture Spirale" : "Spiralbindung",
    "Couverture Souple" : "Weicher Einband",
    "Couverture Rigide" : "Fester Einband",
    "Rigide & Ouverture à plat" : "Fest & Flachöffnung",
    "Couverture Dos" : "Rückseite des Einbands",
    "Couverture Face" : "Vorderseite des Einbands",
    "Couv." : "Umschl.",
    "Couverture" : "Einband",
    "Ajouter un texte" : "Text hinzufügen",
    "Ajouter un TITRE" : "Einen TITEL hinzufügen",
    "Page" : "Seite",
    "page" : "seite",

    "- La " : "- Die",
    "est vide" : "ist leer",

    // data / repositories
    "Rectangle" : "Rechteck",
    "Triangle" : "Dreieck",
    "Losange" : "Raute",
    "Etoile" : "Stern",
    "Cercle" : "Kreis",
    "Coeur" : "Herz",
    "Polygone" : "Polygon",

    // --- new
    // photo renderer
    "Veuillez attendre la fin du transfer<br>pour pouvoir utiliser cette photo." : "Bitte warten Sie das Ende der Übertragung ab,<br>bevor Sie dieses Foto verwenden.",
    "Intérieur de couverture<br> non imprimable" : "Innenseite des Umschlags<br>nicht druckbar",
    "Votre fichier a été importé !" : "Ihre Datei wurde importiert!",
    "Nous avons converti votre fichier en album. Veuillez vérifier qu'aucun texte important ne soit trop proche des bords</a>. Il risquerai d'être coupé à la fabrication." : "Wir haben Ihre Datei in ein Album umgewandelt. Bitte stellen Sie sicher, dass kein wichtiger Text zu nahe am Rand ist. Er könnte beim Druck abgeschnitten werden.",

    "Appliquer" : "Anwenden",

    "Appliquer à la page courante" : "Auf die aktuelle Seite anwenden",
    "Appliquer à toutes les pages" : "Auf alle Seiten anwenden",
    "Vos mises en page" : "Ihre Layouts",

    "Votre album ne contient pas un nombre de pages multiple de 4." : "Ihr Album enthält keine durch vier teilbare Seitenanzahl.",
    "Par ailleurs, votre album ne contient pas un nombre de pages multiple de 4." : "Außerdem enthält Ihr Album keine durch vier teilbare Seitenanzahl.",
    "Une feuille sera donc ajoutée à la fin de votre ouvrage au moment de la fabrication." : "Ein Blatt wird daher beim Herstellungsprozess am Ende Ihres Werkes hinzugefügt.",

    "Je vérifie votre création.." : "Ich überprüfe deine Fotos..",
    "C'est parti !" : "Los geht's!",

    "Ajouter une photo" : "Ein Foto hinzufügen",
    "Déposez votre photo ici" : "Legen Sie Ihr Foto hier ab",

    "Choisissez la taille de votre album" : "Wählen Sie die Größe Ihres Albums",
    "Prix : <strong>$ €</strong>" : "Preis: <strong>$ €</strong>",
    "Top Vente" : "Bestseller",
    "Souhaitez-vous un format plus grand ?" : "Möchten Sie ein größeres Format?",
    "Souhaitez-vous sublimer votre album ?" : "Möchten Sie Ihr Album veredeln?",
    "Sélectionnez la couverture de votre album" : "Wählen Sie den Umschlag Ihres Albums",
    "Album Rigide + Ouverture à plat" : "Hardcover + Layflat-Album",
    "Indisponible<br>avec la couverture actuelle" : "Nicht verfügbar<br>mit dem aktuellen Einband",
    "Non disponible à cause du nombre de pages de votre album" : "Aufgrund der Seitenanzahl Ihres Albums nicht verfügbar",

    "Ajoutez vos photos" : "Fügen Sie Ihre Fotos hinzu",
    "Sélectionnez vos photos" : "Wählen Sie Ihre Fotos aus",

    "Sélectionnez au minimum 24 photos" : "Wählen Sie mindestens 24 Fotos aus",

    "Je peux créer votre album pour vous !" : "Ich kann Ihr Album für Sie erstellen!",
    "Oui, c'est parti !" : "Ja, los geht's!",
    "Je vais vous créer un magnifique album !" : "Ich werde Ihnen ein<br>wunderbares Album erstellen!",
    "C'est parti" : "Es geht los",
    "Je créé votre album, ca sera rapide !" : "Ich erstelle Ihr Album,<br>es wird schnell gehen!",
    "Votre album est prêt !" : "Ihr Album ist fertig!",

    "Retourner à votre album" : "Zurück zu Ihrem Album",
    "J'analyse vos photos" : "Ich analysiere Ihre Fotos",
    "J'analyse vos photos ($%)" : "Ich analysiere Ihre Fotos ($%)",
    "Quel titre pour votre album ?" : "Welcher Titel für Ihr Album?",

    "Choisissez une proposition ou saisissez le vôtre." : "Wählen Sie einen Vorschlag oder geben Sie Ihren eigenen ein.",

    "Le titre de votre album" : "Der Titel Ihres Albums",

    "Je cherche des idées de titre..." : "Ich suche Titelideen...",

    "Créer mon album" : "Mein Album erstellen",

    "Le $" : "$",
    "Début $" : "Anfang $",

    "Été $" : "Sommer $",

    "Fin $" : "Ende $",

    "Année $" : "Jahr $",
    "Souhaitez-vous que je crée votre album photo ?" : "Soll ich Ihr Fotoalbum erstellen?",
    "Composition intelligente" : "Intelligente Gestaltung",
    "Je crée votre album pour vous !" : "Ich gestalte Ihr Album für Sie!",
    "Vos photos rangées par date, posées sur des pages équilibrées. Vous n'avez plus qu'à relire." : "Ihre Fotos nach Datum geordnet und auf ausgewogene Seiten gesetzt. Sie müssen nur noch durchsehen.",
    "Ordre chronologique respecté" : "Chronologische Reihenfolge bleibt",
    "Chaque page modifiable" : "Jede Seite bearbeitbar",
    "Prêt en quelques secondes" : "In wenigen Sekunden fertig",
    "Composer mon album" : "Mein Album gestalten",
    "Non merci" : "Nein, danke",
    "Le contenu de votre album va être remplacé" : "Der Inhalt Ihres Albums wird ersetzt",

    "Vos photos seront placées par ordre chronologique,<br>et vous n'aurez plus qu'à vérifier votre album." : "Ihre Fotos werden chronologisch platziert,<br>Sie müssen Ihr Album nur noch prüfen.",

    "Attention : votre contenu sera totalement remplacé." : "Achtung: Ihr Inhalt wird vollständig ersetzt.",

    "Oui, Créez mon album" : "Ja, mein Album erstellen",

    "Non, merci" : "Nein, danke",

    "Je récupère vos photos" : "Ich hole Ihre Fotos ab",
    "© $" : "© $",
    "du $ au $" : "vom $ bis $",
    "du $ au $ $" : "vom $ bis $ $",
    "Une fin d'année réunis" : "Gemeinsam zum Jahresende",
    "Un week-end en images" : "Ein Wochenende in Bildern",
    "Nos bons moments" : "Unsere schönen Momente",
    "Le livre de recettes" : "Das Rezeptbuch",
    "Nos recettes de famille" : "Unsere Familienrezepte",
    "Mes recettes" : "Meine Rezepte",
    "Moment de famille" : "Familienmoment",
    "Réunion de famille" : "Familientreffen",
    "Fête de famille" : "Familienfest",
    "Nos compagnons" : "Unsere Begleiter",
    "Mon compagnon" : "Mein Begleiter",
    "Mon animal" : "Mein Tier",
    "Nous deux" : "Wir zwei",
    "Toi et moi" : "Du und ich",
    "Notre histoire" : "Unsere Geschichte",
    "Nos premiers moments" : "Unsere ersten Momente",
    "Bienvenue au monde" : "Willkommen auf der Welt",
    "Notre petit ange" : "Unser kleiner Engel",
    "Souvenirs de voyage" : "Reiseerinnerungen",
    "Carnet de voyage" : "Reisetagebuch",
    "Oui pour la vie" : "Ja für immer",
    "Notre plus beau jour" : "Unser schönster Tag",
    "Notre Mariage" : "Unsere Hochzeit",
    "Joyeux anniversaire" : "Alles Gute zum Geburtstag",
    "Mon anniversaire" : "Mein Geburtstag",
    "Une année de plus" : "Ein Jahr mehr",
    "Notre soirée" : "Unser Abend",
    "Entre amis" : "Unter Freunden",
    "C'était la fête" : "Was für ein Fest",
    "Notre voyage" : "Unsere Reise",
    "J'affine mes propositions ..." : "Ich verfeinere meine Vorschläge ...",
    "On feuillette vos $ photos…" : "Ich blättere durch Ihre $ Fotos…",
    "On repère les moments forts…" : "Ich suche die schönsten Momente…",
    "On imagine 3 titres…" : "Ich überlege mir 3 Titel…",
    "C'est plus long que prévu, on y est presque…" : "Es dauert länger als gedacht, gleich geschafft…",
    "Un instant, je place vos photos..." : "Einen Moment, ich platziere Ihre Fotos...",
    "Week-end à $" : "Wochenende in $",

    "Un saut à $" : "Ein Abstecher nach $",

    "Escapade à $" : "Kurztrip nach $",

    "Une journée à $" : "Ein Tag in $",

    "Une semaine à $" : "Eine Woche in $",

    "À la découverte de $" : "$ entdecken",

    "Nos vacances à $" : "Unser Urlaub in $",

    "Un voyage à $" : "Eine Reise nach $",

    "Les vacances de Noël à $" : "Weihnachtsferien in $",

    "La fin d'année à $" : "Jahresende in $",

    "Un été à $" : "Ein Sommer in $",

    "Notre week-end : $" : "Unser Wochenende: $",

    "Nos vacances : $" : "Unser Urlaub: $",

    "Souvenirs : $" : "Erinnerungen: $",

    "Découverte : $" : "Entdeckung: $",

    "Noël : $" : "Weihnachten: $",

    "Les fêtes : $" : "Die Feiertage: $",

    "Un été : $" : "Ein Sommer: $",

    "Noël $" : "Weihnachten $",

    "Les fêtes de fin d'année" : "Die Feiertage",

    "Notre week-end" : "Unser Wochenende",

    "Un week-end en famille" : "Ein Familienwochenende",

    "Nos vacances" : "Unser Urlaub",

    "Souvenirs de vacances" : "Urlaubserinnerungen",

    "L'été $" : "Sommer $",

    "Nos souvenirs de $" : "Unsere Erinnerungen an $",

    "Nos plus beaux moments" : "Unsere schönsten Momente",
    "Un mobile" : "Ein Handy",
    "Votre ordinateur" : "Ihr Computer",
    "Réseaux sociaux" : "Soziale",
    "Autre" : "Andere",
    "Facebook" : "Facebook",
    "Instagram" : "Instagram",
    "Google" : "Google",
    "Fichier PDF" : "PDF-Datei",
    "Vos Albums" : "Ihre Alben",

    "Connecté à Google Photos sur " : "Verbunden mit Google Fotos auf",
    "Se déconnecter" : "Abmelden",

    //  edition
    "Zoom -" : "Zoom -",
    "Zoom +" : "Zoom +",
    "Rotation" : "Drehung",
    "Bord" : "Rand",
    "Forme" : "Form",
    "Effet" : "Effekt",
    "Descendre" : "Nach unten",
    "Remonter" : "Nach oben",


    "Inverser" : "Umkehren",
    "Gras" : "Fett",
    "Italic" : "Kursiv",
    "Fond" : "Hintergrund",
    "Gauche" : "Links",
    "Centre" : "Mitte",
    "Droite" : "Rechts",

    "Les détails de votre album" : "Details zu Ihrem Album",
    "J'ai compris" : "Ich habe verstanden",

    "Le format de fichier que vous avez sélectionné est incorrect." : "Das von Ihnen gewählte Dateiformat ist falsch.",
    "Veuillez choisir un fichier avec une extension valide (.pdf)" : "Bitte wählen Sie eine Datei mit einer gültigen Erweiterung (.pdf)",

    "De $ à $ pages": "Von $ bis $ Seiten",
    "Album $, $": "Album $, $",
    "Pages": "Seiten",
    "A partir de $": "Ab $",
    "Refaire": "Wiederholen",
    "Ajouter des photos": "Fotos hinzufügen",
    "Veuillez ajouter au moins $ photos" : "Mindestens $ Fotos hinzu",
    "Vous devez avoir au moins <span class='numPhotosLabel'>$ photos</span> pour commander vos tirages" : "Sie müssen mindestens <span class='numPhotosLabel'>$ Fotos</span> haben, um Ihre Abzüge zu bestellen",
    "Vous devez avoir moins de <span class='numPhotosLabel'>$ photos</span> pour commander vos tirages" : "Sie müssen weniger als <span class='numPhotosLabel'>$ Fotos</span> haben, um Ihre Abzüge zu bestellen",

    "Vous devez avoir au moins <span class='numPhotosLabel'>$ photos</span> pour commander votre album" : "Sie müssen mindestens <span class='numPhotosLabel'>$ Fotos</span> haben, um Ihr Album zu bestellen",
    "Vous devez avoir moins de <span class='numPhotosLabel'>$ photos</span> pour commander votre album" : "Sie müssen weniger als <span class='numPhotosLabel'>$ Fotos</span> haben, um Ihr Album zu bestellen",

    "Trier / filtrer vos photos": "Fotos sortieren / filtern",
    "Ajoutez des photos puis cliquez ici pour les placer automatiquement": "Fotos hinzufügen und dann hier klicken, um sie automatisch zu platzieren",
    "Cliquez pour changer la taille ou la couverture": "Klicken, um Größe oder Umschlag zu ändern",
    "Cliquez pour changer la taille de votre cadre": "Klicken Sie, um die Größe Ihres Rahmens zu ändern",
    "Cliquez pour changer la taille de votre affiche": "Klicken Sie, um die Größe Ihres Posters zu ändern",
    "Cliquez pour changer la taille" : "Klicken Sie, um die Größe zu ändern",
    "contient une zone photo vide": "enthält einen leeren Fotobereich",
    "contient $ zones photo vides": "enthält $ leere Fotobereiche",
    "Transparence": "Transparenz",
    "Vous devez ajouter au moins 24 photos": "Sie müssen mindestens 24 Fotos hinzufügen",
    "Quel type d'album souhaitez-vous créer ?": "Welche Art von Album möchten Sie erstellen?",
    "Choisissez le thème de votre album": "Wählen Sie das Thema Ihres Albums",
    "Type d'album": "Albumart",
    "Budget": "Budget",
    "Thèmes": "Themen",
    "Votre Album": "Ihr Album",
    "Cliquez ici pour agrandir": "Klicken Sie hier, um zu vergrößern",
    "Bienvenue dans votre album": "Willkommen in Ihrem Album",
    "Voici quelques informations rapides<br>avant de commencer": "Hier sind einige schnelle Informationen<br>bevor Sie beginnen",
    "L'effet 3D sera appliqué lors de l'impression de votre album.<br><br>2 paires de lunettes 3D<br>seront incluses dans votre colis.<br><br><span class='blue bold'>Vous ne verrez pas l'effet 3D dans l'éditeur</span>": "Der 3D-Effekt wird beim Druck Ihres Albums angewendet.<br><br>2 Paar 3D-Brillen<br>werden in Ihrem Paket enthalten sein.<br><br><span class='blue bold'>Sie werden den 3D-Effekt im Editor nicht sehen</span>",
    "L'effet 3D sera appliqué lors de<br>l'impression de votre album.<br><br>2 paires de lunettes 3D<br>seront incluses dans votre colis.<br><br><span class='blue bold'>Vous ne verrez pas<br>l'effet 3D dans l'éditeur</span>": "Der 3D-Effekt wird während<br>des Druckens Ihres Albums angewendet.<br><br>2 Paar 3D-Brillen<br>werden in Ihrem Paket enthalten sein.<br><br><span class='blue bold'>Sie werden den 3D-Effekt im Editor nicht sehen</span>",
    "Choisissez bien vos photos, pour un <span class='green'>effet optimal</span>": "Wählen Sie Ihre Fotos sorgfältig für einen <span class='green'>optimalen Effekt</span>.",
    "Choisissez bien vos photos<br>pour un <span class='green'>effet optimal</span>": "Wählen Sie Ihre Fotos sorgfältig<br>für einen <span class='green'>optimalen Effekt</span>.",
    "Arrière plan avec de la matière<br>et une profondeur raisonnable": "Hintergrund mit Material<br>und angemessener Tiefe",
    "Sujet au<br>premier plan": "Thema im<br>Vordergrund",
    "de 1 à 4<br>personnes max": "von 1 bis 4<br>Personen max",
    "Vue page": "Seitenansicht",
    "Coller": "Einfügen",
    "Album Blanc": "Weißes Album",
    "Marge de découpe": "Schnittkante",
    "Votre album est sauvegardé !": "Ihr Album wurde gespeichert!",
    "A partir de maintenant, votre album est sauvegardé automatiquement.": "Ab jetzt wird Ihr Album automatisch gespeichert.",

    "Comment faire ?" : "Wie macht man das?",
    "Entrez votre numéro de téléphone portable. Vous recevrez un sms avec le lien de l'application. Vous pourrez alors envoyer vos photos vers votre albums." :  "Geben Sie Ihre Handynummer ein. Sie erhalten eine SMS mit dem Link zur Anwendung. Dann können Sie Ihre Fotos in Ihr Album senden.",
    "Téléphone" : "Telefon",
    "numéro invalide": "ungültige Nummer",
    "C'est parti !" : "Los geht's!",
    "plus rapide" :  "schneller",
    "Scannez ce QRcode pour récupérer les photos depuis votre mobile" :  "Scannen Sie diesen QR-Code, um die Fotos von Ihrem Handy abzurufen.",

    // Ajout de pages

    "Vierges": "Leere",
    "Thématiques": "Themen",
    "Ajouter des pages": "Seiten hinzufügen",
    "jusqu'à $ pages ($€ par pages)": "bis zu $ Seiten ($€ pro Seite)",
    "$ pages": "$ Seiten",
    "Vous avez atteint le nombre maximum de pages": "Sie haben die maximale Seitenanzahl erreicht",

    // Countries
    "Afghanistan": "Afghanistan",
    "Albanie": "Albanien",
    "Algérie": "Algerien",
    "Samoa Américaines": "Amerikanisch-Samoa",
    "Andorre": "Andorra",
    "Angola": "Angola",
    "Anguilla": "Anguilla",
    "Antarctique": "Antarktis",
    "Antigua-et-Barbuda": "Antigua und Barbuda",
    "Argentine": "Argentinien",
    "Arménie": "Armenien",
    "Aruba": "Aruba",
    "Australie": "Australien",
    "Autriche": "Österreich",
    "Azerbaïdjan": "Aserbaidschan",
    "Bahamas": "Bahamas",
    "Bahreïn": "Bahrain",
    "Bangladesh": "Bangladesch",
    "Barbade": "Barbados",
    "Bélarus": "Belarus",
    "Belgique": "Belgien",
    "Belize": "Belize",
    "Bénin": "Benin",
    "Bermudes": "Bermuda",
    "Bhoutan": "Bhutan",
    "Bolivie": "Bolivien",
    "Bosnie-Herzégovine": "Bosnien und Herzegowina",
    "Botswana": "Botswana",
    "Île Bouvet": "Bouvetinsel",
    "Brésil": "Brasilien",
    "Territoire britannique de l'océan Indien": "Britisches Territorium im Indischen Ozean",
    "Îles Vierges britanniques": "Britische Jungferninseln",
    "Brunei Darussalam": "Brunei Darussalam",
    "Bulgarie": "Bulgarien",
    "Burkina Faso": "Burkina Faso",
    "Burundi": "Burundi",
    "Cambodge": "Kambodscha",
    "Cameroun": "Kamerun",
    "Canada": "Kanada",
    "Cap-Vert": "Kap Verde",
    "Îles Caïmans": "Kaimaninseln",
    "République centrafricaine": "Zentralafrikanische Republik",
    "Tchad": "Tschad",
    "Chili": "Chile",
    "Chine": "China",
    "Île Christmas": "Weihnachtsinsel",
    "Îles Cocos (Keeling)": "Kokosinseln (Keeling)",
    "Colombie": "Kolumbien",
    "Comores": "Komoren",
    "Congo": "Kongo",
    "République démocratique du Congo": "Demokratische Republik Kongo",
    "Îles Cook": "Cookinseln",
    "Costa Rica": "Costa Rica",
    "Croatie": "Kroatien",
    "Cuba": "Kuba",
    "Chypre": "Zypern",
    "République tchèque": "Tschechische Republik",
    "Danemark": "Dänemark",
    "Djibouti": "Dschibuti",
    "Dominique": "Dominica",
    "République dominicaine": "Dominikanische Republik",
    "Équateur": "Ecuador",
    "Égypte": "Ägypten",
    "Salvador": "El Salvador",
    "Guinée équatoriale": "Äquatorialguinea",
    "Érythrée": "Eritrea",
    "Estonie": "Estland",
    "Éthiopie": "Äthiopien",
    "Îles Malouines": "Falklandinseln",
    "Îles Féroé": "Färöer Inseln",
    "Fidji": "Fidschi",
    "Finlande": "Finnland",
    "France": "Frankreich",
    "Guyane française": "Französisch-Guayana",
    "Polynésie française": "Französisch-Polynesien",
    "Terres australes françaises": "Französische Süd- und Antarktisgebiete",
    "Gabon": "Gabun",
    "Gambie": "Gambia",
    "Géorgie": "Georgien",
    "Allemagne": "Deutschland",
    "Ghana": "Ghana",
    "Gibraltar": "Gibraltar",
    "Grèce": "Griechenland",
    "Groenland": "Grönland",
    "Grenade": "Grenada",
    "Guadeloupe": "Guadeloupe",
    "Guam": "Guam",
    "Guatemala": "Guatemala",
    "Guernesey": "Guernsey",
    "Guinée": "Guinea",
    "Guinée-Bissau": "Guinea-Bissau",
    "Guyane": "Guyana",
    "Haïti": "Haiti",
    "Îles Heard-et-MacDonald": "Heard und McDonaldinseln",
    "Saint-Siège (État de la Cité du Vatican)": "Heiliger Stuhl (Vatikanstadt)",
    "Honduras": "Honduras",
    "Hong Kong": "Hongkong",
    "Hongrie": "Ungarn",
    "Islande": "Island",
    "Inde": "Indien",
    "Indonésie": "Indonesien",
    "Iran": "Iran",
    "Iraq": "Irak",
    "Irlande": "Irland",
    "Île de Man": "Isle of Man",
    "Israël": "Israel",
    "Italie": "Italien",
    "Jamaïque": "Jamaika",
    "Japon": "Japan",
    "Jersey": "Jersey",
    "Jordanie": "Jordan",
    "Kazakhstan": "Kasachstan",
    "Kenya": "Kenia",
    "Kiribati": "Kiribati",
    "Corée du Nord": "Nordkorea",
    "Corée du Sud": "Südkorea",
    "Koweït": "Kuwait",
    "Kirghizistan": "Kirgisistan",
    "Laos": "Laos",
    "Lettonie": "Lettland",
    "Liban": "Libanon",
    "Lesotho": "Lesotho",
    "Libéria": "Liberia",
    "Libye": "Libyen",
    "Liechtenstein": "Liechtenstein",
    "Lituanie": "Litauen",
    "Luxembourg": "Luxemburg",
    "Macao": "Macao",
    "Macédoine du Nord": "Nordmazedonien",
    "Madagascar": "Madagaskar",
    "Malawi": "Malawi",
    "Malaisie": "Malaysia",
    "Maldives": "Malediven",
    "Mali": "Mali",
    "Malte": "Malta",
    "Îles Marshall": "Marshallinseln",
    "Martinique": "Martinique",
    "Mauritanie": "Mauretanien",
    "Maurice": "Mauritius",
    "Mayotte": "Mayotte",
    "Mexique": "Mexiko",
    "Micronésie": "Mikronesien",
    "Moldavie": "Moldawien",
    "Monaco": "Monaco",
    "Mongolie": "Mongolei",
    "Monténégro": "Montenegro",
    "Montserrat": "Montserrat",
    "Maroc": "Marokko",
    "Mozambique": "Mosambik",
    "Myanmar": "Myanmar",
    "Namibie": "Namibia",
    "Nauru": "Nauru",
    "Népal": "Nepal",
    "Pays-Bas": "Niederlande",
    "Nouvelle-Calédonie": "Neukaledonien",
    "Nouvelle-Zélande": "Neuseeland",
    "Nicaragua": "Nicaragua",
    "Niger": "Niger",
    "Nigeria": "Nigeria",
    "Niue": "Niue",
    "Île Norfolk": "Norfolkinsel",
    "Îles Mariannes du Nord": "Nördliche Marianen",
    "Norvège": "Norwegen",
    "Oman": "Oman",
    "Pakistan": "Pakistan",
    "Palaos": "Palaos",
    "Palestine": "Palästina",
    "Panama": "Panama",
    "Papouasie-Nouvelle-Guinée": "Papua-Neuguinea",
    "Paraguay": "Paraguay",
    "Pérou": "Peru",
    "Philippines": "Philippinen",
    "Îles Pitcairn": "Pitcairninseln",
    "Pologne": "Polen",
    "Portugal": "Portugal",
    "Porto Rico": "Puerto Rico",
    "Qatar": "Katar",
    "Réunion": "Réunion",
    "Roumanie": "Rumänien",
    "Russie": "Russland",
    "Rwanda": "Ruanda",
    "Saint-Barthélemy": "Saint-Barthélemy",
    "Sainte-Hélène, Ascension et Tristan da Cunha": "St. Helena, Ascension und Tristan da Cunha",
    "Saint-Christophe-et-Niévès": "St. Kitts und Nevis",
    "Sainte-Lucie": "St. Lucia",
    "Saint-Martin (partie française)": "Saint Martin (französischer Teil)",
    "Saint-Pierre-et-Miquelon": "Saint-Pierre und Miquelon",
    "Saint-Vincent-et-les-Grenadines": "St. Vincent und die Grenadinen",
    "Samoa": "Samoa",
    "Saint-Marin": "San Marino",
    "Sao Tomé-et-Principe": "São Tomé und Príncipe",
    "Arabie saoudite": "Saudi-Arabien",
    "Sénégal": "Senegal",
    "Serbie": "Serbien",
    "Seychelles": "Seychellen",
    "Sierra Leone": "Sierra Leone",
    "Singapour": "Singapur",
    "Saint-Martin (partie néerlandaise)": "Sint Maarten (niederländischer Teil)",
    "Slovaquie": "Slowakei",
    "Slovénie": "Slowenien",
    "Îles Salomon": "Salomonen",
    "Somalie": "Somalia",
    "Afrique du Sud": "Südafrika",
    "Géorgie du Sud-et-les Îles Sandwich du Sud": "Südgeorgien und die Südlichen Sandwichinseln",
    "Soudan du Sud": "Südsudan",
    "Espagne": "Spanien",
    "Sri Lanka": "Sri Lanka",
    "Soudan": "Sudan",
    "Suriname": "Suriname",
    "Svalbard et Île Jan Mayen": "Svalbard und Jan Mayen",
    "Eswatini": "Eswatini",
    "Suède": "Schweden",
    "Suisse": "Schweiz",
    "Syrie": "Syrien",
    "Taïwan": "Taiwan",
    "Tadjikistan": "Tadschikistan",
    "Tanzanie": "Tansania",
    "Thaïlande": "Thailand",
    "Timor oriental": "Osttimor",
    "Togo": "Togo",
    "Tokelau": "Tokelau",
    "Tonga": "Tonga",
    "Trinité-et-Tobago": "Trinidad und Tobago",
    "Tunisie": "Tunesien",
    "Turquie": "Türkei",
    "Turkménistan": "Turkmenistan",
    "Îles Turques-et-Caïques": "Turks- und Caicosinseln",
    "Tuvalu": "Tuvalu",
    "Ouganda": "Uganda",
    "Ukraine": "Ukraine",
    "Émirats arabes unis": "Vereinigte Arabische Emirate",
    "Royaume-Uni": "Vereinigtes Königreich",
    "États-Unis": "Vereinigte Staaten",
    "Îles mineures éloignées des États-Unis": "Kleinere Amerikanische Überseeinseln",
    "Uruguay": "Uruguay",
    "Ouzbékistan": "Usbekistan",
    "Vanuatu": "Vanuatu",
    "Venezuela": "Venezuela",
    "Viêt Nam": "Vietnam",
    "Îles Vierges britanniques": "Britische Jungferninseln",
    "Îles Vierges des États-Unis": "Amerikanische Jungferninseln",
    "Wallis-et-Futuna": "Wallis und Futuna",
    "Sahara occidental": "Westsahara",
    "Yémen": "Jemen",
    "Zambie": "Sambia",
    "Zimbabwe": "Simbabwe",
    "Vous allez recevoir un sms !" : "Sie werden eine SMS erhalten!",
    "Dans quelques instants, vous recevrez un sms. Cliquez sur le lien, et envoyez vos photos." : "In wenigen Augenblicken werden Sie eine SMS erhalten. Klicken Sie auf den Link und senden Sie Ihre Fotos.",

    "Changer de Thématique" : "Design wechseln",

    "Couvertures pour votre album" : "Umschläge für Ihr Album",
    "Modèles pour vos pages" : "Vorlagen für Ihre Seiten",

    "Thème" : "Design",
    "Taille" : "Größe",
    "Finition" : "Verarbeitung",

    "Un Instant ..." : "Ein Moment ...",
    "C'est presque bon !" : "Es ist fast fertig!",
    "Je sélectionne les meilleures photos" : "Ich wähle die besten Fotos aus",
    "Je créé votre histoire ..." : "Ich erstelle Ihre Geschichte...",

    "Mise en page aléatoire" : "Zufällige Seitengestaltung",
    "<b>$</b> vous a envoyé" : "<b>$</b> hat Ihnen gesendet",
    "Refuser" : "Ablehnen",
    "Voir les photos" : "Fotos ansehen",
    "Vous allez perdre les photos partagées de $." : "Sie werden die geteilten Fotos von $ verlieren.",
    "Êtes vous sûr de vouloir quitter?" : "Sind Sie sicher, dass Sie verlassen möchten?",
    "Vous allez perdre les photos partagées de $. Êtes vous sûr de vouloir quitter?" : "Sie werden die geteilten Fotos von $ verlieren. Sind Sie sicher, dass Sie verlassen möchten?",
    "Sélectionnez les photos que vous souhaitez garder" : "Wählen Sie die Fotos aus, die Sie behalten möchten",
    "Tout sélectionner ($)" : "Alles auswählen ($)",
    "Tout déselectionner ($)" : "Alles abwählen ($)",
    "Valider ($)" : "Bestätigen ($)",
    "Importer ($)" : "Importieren ($)",
    "Choisissez vos photos dans la fenêtre Google. Elles arriveront ici.": "Wählen Sie Ihre Fotos im Google-Fenster aus. Sie erscheinen hier.",
    "Vos photos" : "Ihre Fotos",
    "$ photos reçues" : "$ Fotos empfangen",
    "$ sur $ photos reçues" : "$ von $ Fotos empfangen",
    "Vos photos arrivent" : "Ihre Fotos treffen ein",
    "Envoyez vos photos depuis votre mobile" : "Senden Sie Ihre Fotos von Ihrem Handy",
    "Ouvrez le lien reçu par SMS et choisissez vos photos." : "Öffnen Sie den per SMS erhaltenen Link und wählen Sie Ihre Fotos aus.",
    "En attente du téléphone" : "Warten auf das Telefon",
    "Nous attendons vos photos…" : "Wir warten auf Ihre Fotos…",
    "Gardez cette page ouverte. Les photos apparaîtront ici dès leur arrivée." : "Lassen Sie diese Seite geöffnet. Ihre Fotos erscheinen hier, sobald sie eintreffen.",
    "Aucune photo reçue" : "Noch keine Fotos empfangen",
    "Continuez l'envoi depuis votre mobile, la liste se met à jour toute seule." : "Senden Sie weiter von Ihrem Handy – die Liste aktualisiert sich automatisch.",
    "Réception en cours" : "Empfang läuft",
    "Vos photos sont prêtes" : "Ihre Fotos sind bereit",
    "Importez-les dans votre album pour commencer la mise en page." : "Importieren Sie sie in Ihr Album, um mit der Gestaltung zu beginnen.",
    "$ photos seront ajoutées à votre album" : "$ Fotos werden Ihrem Album hinzugefügt",
    "Envoi pas encore terminé" : "Upload noch nicht abgeschlossen",
    "Vos photos arrivent encore depuis votre mobile. Importer seulement les $ photos déjà reçues ?" : "Ihre Fotos treffen noch von Ihrem Handy ein. Nur die $ bereits empfangenen importieren?",
    "Importer $ photos" : "$ Fotos importieren",
    "Continuer l'attente" : "Weiter warten",


    // Google Photos import (SelectPhotosPanel)
    "Importez-les pour les ajouter à votre création." : "Importieren Sie sie, um sie Ihrer Kreation hinzuzufügen.",
    "$ photos seront importées" : "$ Fotos werden importiert",
    "Aucune photo n'a été reçue." : "Es wurden keine Fotos empfangen.",
    "Aucune photo n'a pu être récupérée." : "Es konnten keine Fotos abgerufen werden.",
    "Récupération de vos photos Google" : "Ihre Google-Fotos werden abgerufen",
    "Nous les récupérons depuis Google Photos, cela peut prendre un moment." : "Wir holen sie von Google Fotos, das kann einen Moment dauern.",
    "Connexion à Google Photos" : "Verbindung zu Google Fotos",
    "Nous récupérons vos photos…" : "Ihre Fotos werden abgerufen…",
    "Elles sont récupérées depuis Google Photos, la liste se met à jour toute seule." : "Sie werden von Google Fotos geholt – die Liste aktualisiert sich automatisch.",
    "Récupération en cours" : "Wird abgerufen",
    "Récupération pas encore terminée" : "Abruf noch nicht abgeschlossen",
    "La récupération des photos depuis Google n'est pas terminée. Souhaitez-vous importer seulement les $ photos affichées ?" : "Ihre Fotos werden noch von Google abgerufen. Nur die $ angezeigten importieren?",


    "Appuyez ici pour tourner les pages":"Hier klicken, um die Seiten umzublättern",
    "Au cas ou...":"Falls nötig...",
    "Vous pouvez annulez vos<br>modifications ici":"Sie können Ihre<br>Änderungen hier rückgängig machen",
    "On Commence ?":"Fangen wir an?",
    //"Choisissez la couverture<br>de votre album":"Wählen Sie den Umschlag<br>Ihres Albums",
    "Commencez par sélectionner vos photos !" : "Wählen Sie zuerst Ihre Fotos aus!",
    "Personne":"Person",
    "Trier par personne":"Nach Person sortieren",
    "Sélectionnez vos photos depuis :":"Wählen Sie Ihre Fotos aus :",
    "Ajouter 2 pages":"2 Seiten hinzufügen",
    "Couvertures":"Umschläge",
    "Texte de la tranche":"Text für den Buchrücken",
    "Besoin de Recadrer ?":"Zuschneiden nötig ?",
    "Appuyez une seconde fois<br>sur la photo.":"Tippen Sie ein zweites Mal<br>auf das Foto.",
    "Classique":"Klassisch",
    "Mises en page":"Layouts",
    "Images":"Bilder",
    "Toutes":"Alle",
    "Non Utilisées":"Unbenutzte",
    "Remplacer":"Ersetzen",
    "Effets":"Effekte",
    "Valider":"Bestätigen",
    "Zoomer/Recadrez":"Zoomen/Zuschneiden",
    "Supprimer 2 pages":"2 Seiten löschen",
    'Vos Creations' : 'Ihre Kreationen',

    "Corriger" : "Korrigieren",

    "Nombre de photos insuffisant" : "Unzureichende Anzahl an Fotos",
    "Veuillez sélectionner au minimum 24 photos." : "Bitte wählen Sie mindestens 24 Fotos aus.",

    "Importez vos photos en cliquant sur le bouton ici." : "Importieren Sie Ihre Fotos, indem Sie hier auf die Schaltfläche klicken.",
    "Ajoutez une photo" : "Fügen Sie ein Foto hinzu",
    "Appuyez sur une photo ou faîtes-la glisser vers votre page" : "Tippen Sie auf ein Foto oder ziehen Sie es auf Ihre Seite",

    "Quel type d'album souhaitez-vous créer?" : "Welche Art von Album möchten Sie erstellen?",

    "Tirage $" : "Fotodruck $",
    "$/$ photos" : "$/$ fotos",
    "$ photos" : "$ fotos",

    "Nombre de photo maximum" : "Maximale Anzahl an Fotos",
    "Vous avez atteint le nombre maximum de photos" : "Sie haben die maximale Anzahl an Fotos erreicht",


    "Choisissez la taille de votre cadre" : "Wählen Sie die Größe Ihres Rahmens",

    "Passer": "Überspringen",

    "Cadre Photo" : "Bilderrahmen",
    "Poster Photo" : "Poster drucken",

    "Ajoutez vos photos<br>en cliquant ici" : "Fügen Sie Ihre Fotos hinzu<br>indem Sie hier klicken",

    "Choisissez les photos<br>à ajouter à votre cadre" : "Fotos für Ihren<br>Rahmen auswählen",

    "Votre album n'a pas été sauvegardé. Etes-vous sûre de vouloir quitter cette page ?" : "Ihr Album wurde nicht gespeichert. Sind Sie sicher, dass Sie diese Seite verlassen möchten?",
    "ATTENTION : en quittant sans sauvegarder vous risquez de perdre un partie de votre travail. Veuillez utiliser le bouton QUITTER pour quitter en sauvegardant votre travail." : "ACHTUNG: Wenn Sie ohne Speichern verlassen, könnten Teile Ihrer Arbeit verloren gehen. Bitte verwenden Sie die Schaltfläche VERLASSEN, um zu speichern und zu beenden.",
    
    "Aller au panier (+ $ €)": "Zum Warenkorb gehen (+ $ €)",
    "Continuer sans cadre" : "Ohne Rahmen fortfahren",
    "Continuer sans box" : "Ohne Box fortfahren",

    "Et si on rajoutait un joli papier en plus ?": "Wie wäre es mit einem hübschen Papier dazu?",
    "Et pourquoi pas une box pour ranger vos photos ?": "Wie wäre es mit einer Box zum Aufbewahren Ihrer Fotos?",
    "Pourquoi pas un cadre autour de votre chef d'oeuvre ?": "Wie wäre es mit einem Rahmen für Ihr Meisterwerk?",

    "Pour photos 10 x 10cm" : "Für Fotos 10 x 10 cm",
    "Pour photos 15 x 10cm" : "Für Fotos 15 x 10 cm",

    "Calendrier Bureau" : "Tischkalender",
    "Calendrier Mural" : "Wandkalender",

    "Ajoutez vos photos, puis déplacez-les sur vos pages": "Füge deine Fotos hinzu und ziehe sie auf deine Seiten",
    "Choisissez le mois de démarrage de votre calendrier": "Wähle den Startmonat deines Kalenders",
    "Commencer": "Starten",
    "Janvier": "Januar",
    "Février": "Februar",
    "Mars": "März",
    "Avril": "April",
    "Mai": "Mai",
    "Juin": "Juni",
    "Juillet": "Juli",
    "Août": "August",
    "Septembre": "September",
    "Octobre": "Oktober",
    "Novembre": "November",
    "Décembre": "Dezember",
    "Modifiez votre évènement": "Bearbeite dein Ereignis",
    "Vos dates": "Deine Termine",
    "Vos dates préférées méritent une place ici : anniversaires, voyages, bons moments !": "Deine Lieblingstermine verdienen hier einen Platz: Geburtstage, Reisen, schöne Momente!",
    "Ajoutez un événement en sélectionnant une date dans le calendrier." : "Fügen Sie ein Ereignis hinzu, indem Sie ein Datum im Kalender auswählen.",
    "Ajoutez une date": "Füge ein Datum hinzu",
    "Sélectionnez la date": "Wähle das Datum",
    "Entrez votre évènement": "Gib dein Ereignis ein",
    "Modifiez votre évènement": "Bearbeite dein Ereignis",

    "Lundi": "Montag",
    "Mardi": "Dienstag",
    "Mercredi": "Mittwoch",
    "Jeudi": "Donnerstag",
    "Vendredi": "Freitag",
    "Samedi": "Samstag",
    "Dimanche": "Sonntag",

    "Cliquer pour ajouter une photo" : "Klicken, um ein Foto hinzuzufügen",
    "Ajouter vos photos ici" : "Fügen Sie Ihre Fotos hier hinzu",
    "Choisissez votre modèle<br>Puis ajouter vos photos" : "Wählen Sie Ihr Modell<br>Fügen Sie dann Ihre Fotos hinz",

    "Votre photo n'a pu être transformée, veuillez re-éssayer dans quelques instants." : "Ihr Foto konnte nicht verarbeitet werden, bitte versuchen Sie es in wenigen Augenblicken erneut.",

    "Super photo, félicitations !" : "Tolles Foto, Glückwunsch!",
    "Un peu de magie..." : "Ein bisschen Magie...",
    "Je crée votre poster..." : "Ich erstelle Ihr Poster...",
    "On y est presque..." : "Wir sind fast fertig...",
    "C'est prêt !" : "Es ist fertig!",

    "De préférence une photo de portrait avec des visages visibles" : "Vorzugsweise ein Porträtfoto mit sichtbaren Gesichtern",

    "$ photos minimum" : "$ Fotos mindestens",
    "Tirage Photo" : "Fotodruck",
    "Recadrez votre photo si besoin" : "Schneide dein Foto bei Bedarf zu",
    "Choisissez la finition de votre poster" : "Wähle die Ausführung deines Posters",
    "A partir de" : "Ab",

    "Choisissez la taille de votre poster" : "Wählen Sie die Größe Ihres Posters",
    "Changer" : "Ändern",

    "Cliquez pour changer la finition" : "Klicken Sie, um die Oberfläche zu ändern",
    "On vous propose 4 finitions" : "Wir bieten Ihnen 4 Oberflächen an",
    "Pour la taille, on part sur quoi ?" : "Welche Größe möchten Sie?",
    "Souhaitez-vous un cadre ?" : "Möchten Sie einen Rahmen?",
    "A partir de" : "Ab",

    "C'est parfait !" : "Perfekt!",
    "Nous attendons la réception de vos photos pour continuer.<br/> Vous serez redirigé automatiquement." : "Wir warten auf den Eingang Ihrer Fotos, um fortzufahren.<br/> Sie werden automatisch weitergeleitet.",

    // poster / calendar
    "Modèles pour votre affiche" : "Vorlagen für Ihr Poster",
    "Événements" : "Ereignisse",
    "Appuyez 2 fois sur la photo" : "Tippen Sie zweimal auf das Foto",
    "Recadrez ?" : "Zuschneiden ?",
    "$ photos n'ont pu être envoyées" : "$ Fotos konnten nicht hochgeladen werden",
    "1 photo n'a pu être envoyée" : "1 Foto konnte nicht hochgeladen werden",
    "L'envoi n'était pas terminé quand la page a été fermée, j'ai donc retiré les tirages concernés. Ajoutez à nouveau vos photos, et gardez cette page ouverte jusqu'à la fin de l'envoi." : "Der Upload war noch nicht abgeschlossen, als die Seite geschlossen wurde, deshalb habe ich die betroffenen Abzüge entfernt. Fügen Sie Ihre Fotos erneut hinzu und lassen Sie diese Seite geöffnet, bis der Upload abgeschlossen ist.",
    "Envoi $ %" : "Upload $ %",

    // gomme magique (shared.popups.MagicEraserPopup)
    "Gomme magique" : "Magischer Radierer",
    "Gommer" : "Radieren",
    "Gommer un élément" : "Ein Element entfernen",
    "Comment ça marche ?" : "Wie funktioniert das?",
    "Tout effacer" : "Alles löschen",
    "Gommer la zone" : "Bereich radieren",
    "Gommage…" : "Wird radiert…",
    "Entourez la zone à gommer : tracez un contour fermé autour de l'élément" : "Umkreisen Sie den zu radierenden Bereich: Ziehen Sie eine geschlossene Linie um das Element",
    "L'intérieur du contour sera gommé. Vous pouvez entourer une autre zone." : "Das Innere der Umrandung wird radiert. Sie können einen weiteren Bereich umkreisen.",
    "Ne fermez pas la fenêtre, c'est presque fini." : "Schließen Sie das Fenster nicht, es ist fast fertig.",
    "Voici le résultat. Gardez-le, ou recommencez" : "Hier ist das Ergebnis. Behalten Sie es oder beginnen Sie von vorn",
    "Entourez un élément pour le supprimer de votre photo." : "Umkreisen Sie ein Element, um es von Ihrem Foto zu entfernen.",
    "Recommencer" : "Neu beginnen",
    "Garder" : "Behalten",
    "Avant" : "Vorher",
    "Après" : "Nachher",
    "Veuillez vous reconnecter." : "Bitte melden Sie sich erneut an.",
    "Cette photo n'est pas accessible." : "Dieses Foto ist nicht verfügbar.",
    "La gomme magique est momentanément indisponible." : "Der magische Radierer ist vorübergehend nicht verfügbar.",
    "Cette version de la photo ne peut pas être retouchée." : "Diese Version des Fotos kann nicht bearbeitet werden.",
    "Le tracé n'a pas pu être lu, veuillez réessayer." : "Die Pinselstriche konnten nicht gelesen werden, bitte versuchen Sie es erneut.",
    "Veuillez patienter une minute avant le prochain effacement." : "Bitte warten Sie eine Minute bis zum nächsten Radieren.",
    "Vous avez atteint la limite d'effacements pour aujourd'hui." : "Sie haben das heutige Limit erreicht.",
    "Le traitement prend trop de temps, veuillez réessayer." : "Die Verarbeitung dauert zu lange, bitte versuchen Sie es erneut.",
    "L'effacement a échoué, veuillez réessayer." : "Das Radieren ist fehlgeschlagen, bitte versuchen Sie es erneut.",

    // posters : Aperçu 3D (shared.popups.WallPreviewPopup)
    "Aperçu 3D" : "3D-Vorschau",
    "Voir votre poster sur un mur" : "Ihr Poster an der Wand ansehen",
    "Poster seul" : "Nur Poster",
    "Poster" : "Poster",
    "Cadre bois" : "Holzrahmen",
    "Bois" : "Holz",
    "Cadre noir" : "Schwarzer Rahmen",
    "Noir" : "Schwarz",
    "Cadre blanc" : "Weißer Rahmen",
    "Blanc" : "Weiß",
    "Salon" : "Wohnzimmer",
    "Chambre" : "Schlafzimmer",
    "Cuisine" : "Küche",
    "Salon avec canapé rose" : "Wohnzimmer mit rosa Sofa",
    "Chambre avec lit et commode" : "Schlafzimmer mit Bett und Kommode",
    "Cuisine au mur rose" : "Küche mit rosa Wand",
    "Poster encadré" : "Gerahmtes Poster",
    "Glissez pour faire pivoter · molette pour zoomer" : "Ziehen zum Drehen · Mausrad zum Zoomen",
    "Molette pour zoomer" : "Mausrad zum Zoomen",
    "Vue d'ensemble" : "Gesamtansicht",
    "De près" : "Nahansicht",
    "Dimensions" : "Abmessungen",
    "Pièce" : "Raum",
    "Ensemble" : "Gesamt",
    "Afficher les dimensions" : "Abmessungen anzeigen",
    "Préparation de l'aperçu…" : "Vorschau wird vorbereitet…",

    // posters : the size and finish screens, the editor's options bar
    "Les aperçus sont à la même échelle : comparez d'un coup d'œil." : "Die Vorschauen haben denselben Maßstab: vergleichen Sie auf einen Blick.",
    "Choisissez votre finition" : "Wählen Sie Ihre Ausführung",
    "Comment voulez-vous l'afficher ?" : "Wie möchten Sie es zeigen?",
    "Aperçu avec votre photo, au format $." : "Vorschau mit Ihrem Foto im Format $.",
    "Le + choisi" : "Am häufigsten gewählt",
    "Pas disponible dans cette taille" : "In dieser Größe nicht erhältlich",
    "Options du poster" : "Poster-Optionen",

    // album check before ordering (shared.panels.AlbumCheckPanel)
    "Vérification en cours…" : "Überprüfung läuft…",
    "Nous passons votre album en revue avant l'impression." : "Wir prüfen Ihr Album vor dem Druck.",
    "Votre conseillère Flexilivre" : "Ihre Flexilivre-Beraterin",
    "Votre album a été vérifié" : "Ihr Album wurde überprüft",
    "Corriger mon album" : "Mein Album korrigieren",
    "complété" : "fertig",
    "Tout est parfait, votre album est prêt !" : "Alles perfekt, Ihr Album ist fertig!",
    "Vous y êtes presque !" : "Fast geschafft!",
    "Encore un petit effort !" : "Nur noch ein kleines Stück!",
    "Votre album prend forme" : "Ihr Album nimmt Gestalt an",
    "Vérification des pages" : "Überprüfung der Seiten",
    "Pages remplies" : "Seiten ausgefüllt",
    "Nombre de pages" : "Seitenzahl",
    "1 zone photo vide" : "1 leeres Fotofeld",
    "$ zones photo vides" : "$ leere Fotofelder",
    "imprimées en blanc si vous commandez" : "werden weiß gedruckt, wenn Sie bestellen",
    "1 page vide" : "1 leere Seite",
    "$ pages vides" : "$ leere Seiten",
    "Une feuille sera ajoutée à la fin" : "Am Ende wird ein Blatt hinzugefügt",
    "le nombre de pages n'est pas un multiple de 4" : "die Seitenzahl ist kein Vielfaches von 4",
    "Pages concernées" : "Betroffene Seiten",
    "p. $" : "S. $",
    "$ : validé" : "$: in Ordnung",
    "$ : problème détecté" : "$: Problem gefunden",

    // first pages added (common.popups.AddPagePopup)
    "Conseillère Flexilivre" : "Flexilivre-Beraterin",
    "Psst ! $ pages" : "Psst! $ Seiten",
    "Un album se fait par <strong>4 pages</strong>. Sinon, on complète avec des pages blanches lors de la fabrication." : "Ein Album besteht aus Blöcken von <strong>4 Seiten</strong>. Sonst ergänzen wir bei der Herstellung leere Seiten.",
    "OK, compris" : "OK, verstanden",
});
